import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Setup from "@/pages/Setup";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import BookingPage from "@/pages/BookingPage";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginGate from "@/components/auth/LoginGate";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

// Authenticated workspace shell — every internal route lives here behind
// the AuthGate. Public routes (e.g. /book/:leadId) are mounted OUTSIDE this
// component in App() below so they remain accessible without a session.
function AuthGate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div
        className="min-h-screen grid place-items-center bg-slate-50"
        data-testid="auth-loading"
      >
        <Loader2 className="h-6 w-6 text-slate-500 animate-spin" />
      </div>
    );
  }
  if (!user) return <LoginGate />;
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/leads/:id" element={<LeadDetail />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public booking link — accessible without login, embedded in
              outbound emails / WhatsApp / accelerator suggestions. */}
          <Route path="/book/:leadId" element={<BookingPage />} />
          {/* Everything else flows through the authenticated workspace. */}
          <Route
            path="*"
            element={
              <AuthProvider>
                <AuthGate />
              </AuthProvider>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
